import React, { useState } from 'react';
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Drawer,
  BottomNavigation,
  BottomNavigationAction,
  useMediaQuery
} from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PagesOutlinedIcon from '@mui/icons-material/PagesOutlined';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import InboxIcon from '@mui/icons-material/Inbox';
import { useNavigate } from 'react-router-dom';
import { shades } from '../../../theme';
import { APP_URLS } from '../../../urls';

const SideBar = () => {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const isActive = (path) => location.pathname === path;

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  return (
    <>
      {isSmallScreen
        ? (
          <BottomNavigation
            showLabels
            sx={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              backgroundColor: shades.white[100],
              borderTop: '1px solid #dddddd',
              zIndex: 1000
            }}
          >
            <BottomNavigationAction
              label='Feed'
              icon={<HomeOutlinedIcon />}
              onClick={() => navigate(APP_URLS.mediChatHome)}
              sx={{ color: isActive(APP_URLS.mediChatHome) ? '#2783f7' : shades.neutral[700] }}
            />
            <BottomNavigationAction
              label='Groups'
              icon={<GroupOutlinedIcon />}
              onClick={() => navigate(APP_URLS.mediChatGroups)}
              sx={{ color: isActive(APP_URLS.mediChatGroups) ? '#2783f7' : shades.neutral[700] }}
            />
            <BottomNavigationAction
              label='Pages'
              icon={<PagesOutlinedIcon />}
              onClick={() => navigate(APP_URLS.mediChatPages)}
              sx={{ color: isActive(APP_URLS.mediChatPages) ? '#2783f7' : shades.neutral[700] }}
            />
            <BottomNavigationAction
              label='Profile'
              icon={<ManageAccountsIcon />}
              onClick={() => navigate(APP_URLS.mediChatProfile)}
              sx={{ color: isActive(APP_URLS.mediChatProfile) ? '#2783f7' : shades.neutral[700] }}
            />
            <BottomNavigationAction
              label='Messages'
              icon={<InboxIcon />}
              onClick={() => navigate(APP_URLS.mediChatMessages)}
              sx={{ color: isActive(APP_URLS.mediChatMessages) ? '#2783f7' : shades.neutral[700] }}
            />
          </BottomNavigation>
          )
        : (
          <Drawer
            variant={isDrawerOpen ? 'temporary' : 'permanent'}
            open={isDrawerOpen}
            onClose={toggleDrawer}
            sx={{
              display: { xs: 'none', md: 'block' },
              width: 250,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: 250,
                top: '10vh',
                boxSizing: 'border-box',
                p: 2,
                color: shades.white[100],
                backgroundColor: 'white',
                borderRight: '1px solid #dddddd'
              }
            }}
          >
            <List>
              <ListItemButton
                sx={{
                  color: isActive(APP_URLS.mediChatHome) ? shades.white[100] : shades.neutral[700],
                  backgroundColor: isActive(APP_URLS.mediChatHome) ? '#2783f7' : 'transparent',
                  '&:hover': {
                    backgroundColor: isActive(APP_URLS.mediChatHome) ? '#2783f7' : shades.neutral[100]
                  }
                }}
                onClick={() => navigate(APP_URLS.mediChatHome)}
              >
                <ListItemIcon>
                  <HomeOutlinedIcon fontSize='small' sx={{ color: isActive(APP_URLS.mediChatHome) ? shades.white[100] : shades.neutral[700] }} />
                </ListItemIcon>
                <ListItemText primary='Feed' />
              </ListItemButton>
              <ListItemButton
                sx={{
                  color: isActive(APP_URLS.mediChatGroups) ? shades.white[100] : shades.neutral[700],
                  backgroundColor: isActive(APP_URLS.mediChatGroups) ? '#2783f7' : 'transparent',
                  '&:hover': {
                    backgroundColor: isActive(APP_URLS.mediChatGroups) ? '#2783f7' : shades.neutral[100]
                  }
                }}
                onClick={() => navigate(APP_URLS.mediChatGroups)}
              >
                <ListItemIcon>
                  <GroupOutlinedIcon fontSize='small' sx={{ color: isActive(APP_URLS.mediChatGroups) ? shades.white[100] : shades.neutral[700] }} />
                </ListItemIcon>
                <ListItemText primary='Groups' />
              </ListItemButton>
              <ListItemButton
                sx={{
                  color: isActive(APP_URLS.mediChatPages) ? shades.white[100] : shades.neutral[700],
                  backgroundColor: isActive(APP_URLS.mediChatPages) ? '#2783f7' : 'transparent',
                  '&:hover': {
                    backgroundColor: isActive(APP_URLS.mediChatPages) ? '#2783f7' : shades.neutral[100]
                  }
                }}
                onClick={() => navigate(APP_URLS.mediChatPages)}
              >
                <ListItemIcon>
                  <PagesOutlinedIcon fontSize='small' sx={{ color: isActive(APP_URLS.mediChatPages) ? shades.white[100] : shades.neutral[700] }} />
                </ListItemIcon>
                <ListItemText primary='Pages' />
              </ListItemButton>
              <ListItemButton
                sx={{
                  color: isActive(APP_URLS.mediChatProfile) ? shades.white[100] : shades.neutral[700],
                  backgroundColor: isActive(APP_URLS.mediChatProfile) ? '#2783f7' : 'transparent',
                  '&:hover': {
                    backgroundColor: isActive(APP_URLS.mediChatProfile) ? '#2783f7' : shades.neutral[100]
                  }
                }}
                onClick={() => navigate(APP_URLS.mediChatProfile)}
              >
                <ListItemIcon>
                  <ManageAccountsIcon fontSize='small' sx={{ color: isActive(APP_URLS.mediChatProfile) ? shades.white[100] : shades.neutral[700] }} />
                </ListItemIcon>
                <ListItemText primary='Profile' />
              </ListItemButton>
              <ListItemButton
                sx={{
                  color: isActive(APP_URLS.mediChatMessages) ? shades.white[100] : shades.neutral[700],
                  backgroundColor: isActive(APP_URLS.mediChatMessages) ? '#2783f7' : 'transparent',
                  '&:hover': {
                    backgroundColor: isActive(APP_URLS.mediChatMessages) ? '#2783f7' : shades.neutral[100]
                  }
                }}
                onClick={() => navigate(APP_URLS.mediChatMessages)}
              >
                <ListItemIcon>
                  <InboxIcon fontSize='small' sx={{ color: isActive(APP_URLS.mediChatMessages) ? shades.white[100] : shades.neutral[700] }} />
                </ListItemIcon>
                <ListItemText primary='Messages' />
              </ListItemButton>
            </List>
          </Drawer>
          )}
    </>
  );
};

export default SideBar;
